import Header from "../../components/feature/Header";
import Breadcrumbs from "../../components/feature/Breadcrumbs";
import Footer from "../../components/feature/Footer";
import WhatsAppFloating from "../../components/feature/WhatsAppFloating";
import CookieBanner from "../../components/feature/CookieBanner";
import SEO from "../../components/feature/SEO";
import { useNoIndex } from "../../hooks/useNoIndex";

const cookieTable = [
  {
    nombre: "ptm_cookie_consent_v2",
    tipo: "Técnicas / Esenciales",
    finalidad: "Registra las preferencias de cookies del usuario y el consentimiento otorgado.",
    plazo: "1 año",
    proveedor: "Persianas Toldos Málaga",
  },
  {
    nombre: "session_id",
    tipo: "Técnicas / Esenciales",
    finalidad: "Mantiene la sesión activa del usuario durante la navegación por el sitio.",
    plazo: "Sesión",
    proveedor: "Persianas Toldos Málaga",
  },
  {
    nombre: "csrf_token",
    tipo: "Técnicas / Esenciales",
    finalidad: "Protege los formularios contra ataques de falsificación de petición entre sitios (CSRF).",
    plazo: "Sesión",
    proveedor: "Persianas Toldos Málaga",
  },
  {
    nombre: "_ga",
    tipo: "Analíticas",
    finalidad: "Distingue a los usuarios para Google Analytics 4. Permite contabilizar visitas y sesiones.",
    plazo: "2 años",
    proveedor: "Google LLC",
  },
  {
    nombre: "_ga_*",
    tipo: "Analíticas",
    finalidad: "Cookie específica de la propiedad de Google Analytics 4 para distinguir sesiones.",
    plazo: "2 años",
    proveedor: "Google LLC",
  },
  {
    nombre: "_gid",
    tipo: "Analíticas",
    finalidad: "Distingue a los usuarios para Google Analytics 4 durante un día.",
    plazo: "24 horas",
    proveedor: "Google LLC",
  },
  {
    nombre: "i18nextLng",
    tipo: "Funcionales",
    finalidad: "Recuerda la preferencia de idioma del usuario para futuras visitas.",
    plazo: "1 año",
    proveedor: "Persianas Toldos Málaga",
  },
];

export default function PoliticaCookies() {
  useNoIndex();

  return (
    <div className="min-h-screen bg-white">
      <SEO ogImage="https://persianas-toldos-malaga.es/og/og-default.jpg" ogType="website" />
      <Header />
      <Breadcrumbs />
      <main>
        <section className="py-16 md:py-24">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <h1 className="font-heading font-extrabold text-3xl md:text-4xl text-text-primary mb-3">
              Política de Cookies
            </h1>
            <p className="font-body text-base text-text-secondary mb-12">
              Información sobre las cookies utilizadas en este sitio web conforme a las directrices de la Agencia Española de Protección de Datos (AEPD) y la normativa vigente.
            </p>

            <div className="space-y-10 font-body text-base text-text-secondary leading-relaxed">
              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  1. ¿Qué son las cookies?
                </h2>
                <p className="mb-2">
                  Una cookie es un fichero que se descarga en su dispositivo (ordenador, teléfono móvil, tablet) al acceder a determinadas páginas web. Las cookies permiten a una página web, entre otras cosas, almacenar y recuperar información sobre los hábitos de navegación de un usuario o de su equipo y, dependiendo de la información que contengan y de la forma en que utilice su equipo, pueden utilizarse para reconocer al usuario.
                </p>
                <p>
                  Las cookies no contienen información específica sobre la identidad personal del usuario, aunque los datos personales que almacenamos sobre usted pueden estar vinculados a la información almacenada en y obtenida de las cookies.
                </p>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  2. Tipos de cookies que utilizamos
                </h2>
                <p className="mb-4">
                  En persianas-toldos-malaga.es utilizamos cookies propias y de terceros, clasificadas según su finalidad:
                </p>

                <div className="overflow-x-auto -mx-4 px-4 md:mx-0 md:px-0">
                  <table className="w-full text-sm border-collapse border border-border mb-4">
                    <thead>
                      <tr className="bg-slate-50">
                        <th className="border border-border px-3 py-2.5 text-left font-heading font-bold text-text-primary whitespace-nowrap">Nombre</th>
                        <th className="border border-border px-3 py-2.5 text-left font-heading font-bold text-text-primary whitespace-nowrap">Tipo</th>
                        <th className="border border-border px-3 py-2.5 text-left font-heading font-bold text-text-primary">Finalidad</th>
                        <th className="border border-border px-3 py-2.5 text-left font-heading font-bold text-text-primary whitespace-nowrap">Plazo</th>
                        <th className="border border-border px-3 py-2.5 text-left font-heading font-bold text-text-primary whitespace-nowrap">Proveedor</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cookieTable.map((row, i) => (
                        <tr key={i} className={i % 2 === 1 ? "bg-slate-50/50" : ""}>
                          <td className="border border-border px-3 py-2.5 font-mono text-xs text-text-primary whitespace-nowrap">{row.nombre}</td>
                          <td className="border border-border px-3 py-2.5 whitespace-nowrap">{row.tipo}</td>
                          <td className="border border-border px-3 py-2.5">{row.finalidad}</td>
                          <td className="border border-border px-3 py-2.5 whitespace-nowrap">{row.plazo}</td>
                          <td className="border border-border px-3 py-2.5 whitespace-nowrap">{row.proveedor}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <h3 className="font-heading font-bold text-base text-text-primary mb-2 mt-6">
                  Cookies técnicas (esenciales)
                </h3>
                <p className="mb-3">
                  Son aquellas que permiten la navegación a través de una página web, plataforma o aplicación y la utilización de las diferentes opciones o servicios que en ella existan, incluyendo aquellas que permiten gestionar y operar la página web y habilitar sus funciones y servicios, como, por ejemplo, controlar el tráfico y la comunicación de datos o almacenar contenidos para la difusión de videos o sonido. Estas cookies se instalan de forma automática y no pueden ser desactivadas, ya que sin ellas el sitio web no funcionaría correctamente.
                </p>

                <h3 className="font-heading font-bold text-base text-text-primary mb-2">
                  Cookies analíticas
                </h3>
                <p className="mb-3">
                  Son aquellas que permiten al responsable de las mismas el seguimiento y análisis del comportamiento de los usuarios de los sitios web a los que están vinculadas, incluida la cuantificación de los impactos de los anuncios. La información recogida mediante este tipo de cookies se utiliza en la medición de la actividad de los sitios web, aplicación o plataforma, con el fin de introducir mejoras en función del análisis de los datos de uso que hacen los usuarios del servicio. Estas cookies solo se instalan si usted otorga su consentimiento explícito.
                </p>

                <h3 className="font-heading font-bold text-base text-text-primary mb-2">
                  Cookies funcionales
                </h3>
                <p>
                  Son aquellas que permiten recordar información para que el usuario acceda al servicio con determinadas características que pueden diferenciar su experiencia de la de otros usuarios, como, por ejemplo, el idioma. Estas cookies mejoran la funcionalidad y personalización del sitio web. Pueden ser establecidas por nosotros o por terceros cuyos servicios hemos añadido a nuestras páginas.
                </p>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  3. Consentimiento
                </h2>
                <p className="mb-2">
                  Al acceder a este sitio web por primera vez, se muestra al usuario un banner informativo sobre el uso de cookies, cumpliendo con los requisitos establecidos por la AEPD en su Guía sobre el uso de las cookies (versión 2024).
                </p>
                <p className="mb-2">
                  El banner ofrece tres opciones con igual visibilidad y tamaño:
                </p>
                <ul className="list-disc pl-6 space-y-1.5 mt-2">
                  <li><strong className="text-text-primary">Rechazar:</strong> se instalarán únicamente las cookies técnicas esenciales, imprescindibles para el funcionamiento del sitio web.</li>
                  <li><strong className="text-text-primary">Configurar:</strong> el usuario puede gestionar de forma granular el uso de cookies analíticas y funcionales, activándolas o desactivándolas según su preferencia.</li>
                  <li><strong className="text-text-primary">Aceptar:</strong> se instalarán todas las cookies (técnicas, analíticas y funcionales).</li>
                </ul>
                <p className="mt-3">
                  <strong className="text-text-primary">Importante:</strong> las cookies de terceros no esenciales (analíticas y funcionales) no se cargan hasta que el usuario no otorga su consentimiento explícito. Si usted rechaza las cookies analíticas, Google Analytics 4 no recopilará ningún dato de su navegación.
                </p>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  4. Cómo configurar las cookies en su navegador
                </h2>
                <p className="mb-3">
                  Puede permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las opciones de su navegador. A continuación, se indican los enlaces a las instrucciones de los principales navegadores:
                </p>
                <ul className="list-disc pl-6 space-y-1.5">
                  <li>
                    <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer nofollow" className="text-secondary underline hover:text-secondary-dark transition-colors">
                      Google Chrome y Chrome para Android
                    </a>
                  </li>
                  <li>
                    <a href="https://support.mozilla.org/es/kb/cookies-informacion-que-los-sitios-web-guardan-en-" target="_blank" rel="noopener noreferrer nofollow" className="text-secondary underline hover:text-secondary-dark transition-colors">
                      Mozilla Firefox
                    </a>
                  </li>
                  <li>
                    <a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer nofollow" className="text-secondary underline hover:text-secondary-dark transition-colors">
                      Safari (macOS) y Safari (iOS)
                    </a>
                  </li>
                  <li>
                    <a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-9b28-0634b26a9a15" target="_blank" rel="noopener noreferrer nofollow" className="text-secondary underline hover:text-secondary-dark transition-colors">
                      Microsoft Edge
                    </a>
                  </li>
                </ul>
                <p className="mt-3">
                  Tenga en cuenta que si desactiva las cookies técnicas, algunas funcionalidades del sitio web podrían no operar correctamente.
                </p>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  5. Cookies de terceros
                </h2>
                <p className="mb-2">
                  Este sitio web utiliza servicios de terceros que pueden instalar cookies en su dispositivo. A continuación, se detallan los principales:
                </p>
                <ul className="list-disc pl-6 space-y-1.5 mt-2">
                  <li>
                    <strong className="text-text-primary">Google Analytics 4:</strong> servicio de análisis estadístico proporcionado por Google LLC. Utiliza cookies para recopilar información sobre el uso del sitio web de forma anónima. Puede consultar la <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer nofollow" className="text-secondary underline hover:text-secondary-dark transition-colors">política de privacidad de Google</a>.
                  </li>
                  <li>
                    <strong className="text-text-primary">Google Maps:</strong> servicio de mapas interactivos utilizado en la sección de contacto. Puede consultar la <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer nofollow" className="text-secondary underline hover:text-secondary-dark transition-colors">política de privacidad de Google</a>.
                  </li>
                  <li>
                    <strong className="text-text-primary">WhatsApp (Meta Platforms, Inc.):</strong> widget de contacto directo. Al hacer clic en el botón de WhatsApp, será redirigido a la aplicación de WhatsApp. Puede consultar la <a href="https://www.whatsapp.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer nofollow" className="text-secondary underline hover:text-secondary-dark transition-colors">política de privacidad de WhatsApp</a>.
                  </li>
                </ul>
                <p className="mt-3">
                  La activación de estas cookies de terceros depende exclusivamente del consentimiento otorgado por el usuario a través del banner de cookies.
                </p>
              </section>

              <section>
                <h2 className="font-heading font-bold text-xl text-text-primary mb-4">
                  6. Cambios en la política de cookies
                </h2>
                <p className="mb-2">
                  Persianas Toldos Málaga se reserva el derecho a modificar la presente Política de Cookies en cualquier momento para adaptarla a novedades legislativas o jurisprudenciales, así como a prácticas de la industria.
                </p>
                <p className="mb-2">
                  Cualquier cambio sustancial en el tipo de cookies utilizadas o en los terceros que las gestionan será notificado al usuario mediante la publicación de una actualización en esta página, con una antelación razonable antes de su entrada en vigor.
                </p>
                <p>
                  Se recomienda al usuario consultar periódicamente esta sección para mantenerse informado de las posibles modificaciones. Última actualización: 20 de mayo de 2026.
                </p>
              </section>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppFloating />
      <CookieBanner />
    </div>
  );
}